import { AwaitResponse } from '@general/js/utils/MockUtils';
import { PaymentDetails } from '@/constants/PaymentDetailsMockApiData';
import { PaymentDetailsPageRefData, PaymentSelectionRefData, PremiumImpactPageRefData } from '@/constants/PaymentDetailsMockRefData';
import AbstractClass from './PaymentDetailsAbstractServices';

export default class PaymentDetailsServices extends AbstractClass {
  /**
   * Return mock ref data for payment details selection screen
   */
  static getPaymentDetailsSelectionRefData() {
    return AwaitResponse(JSON.parse(JSON.stringify(PaymentSelectionRefData).tokenSwap()));
  }

  /**
   * Retrieves reference data for view/edit account details screens from CMS BE
   * @returns Ref data object
   */
  static getPaymentDetailsPageReferenceData() {
    return AwaitResponse(JSON.parse(JSON.stringify(PaymentDetailsPageRefData).tokenSwap()));
  }

  /**
   * Retrieves reference data for premium impact/no impact screens from CMS BE
   * @returns Ref data object
   */
  static getPremiumImpactPageReferenceData() {
    return AwaitResponse(JSON.parse(JSON.stringify(PremiumImpactPageRefData).tokenSwap()));
  }

  /**
   *
   */
  static getPaymentDetails() {
    return AwaitResponse(PaymentDetails);
  }

  /**
   *
   */
  static postPaymentDetails() {
    return AwaitResponse({
      oldPremiumAmount: 123.64,
      oldFrequency: 'quarterly',
      newPremiumAmount: 268.64,
      newFrequency: 'semi-annual',
    });
  }
}
